<template>
	<v-main class="py-n12">
		<router-view style="height: 100%" />
	</v-main>
</template>
<script>
export default {
	name: 'MainView',
	components: {},
};
</script>
<style lang="scss">
.v-main__wrap {
	flex: auto !important;
	max-width: 100%;
	position: relative;
}

// percentage heights
@for $i from 0 through 100 {
	.hp-#{$i} {
		height: #{$i + '%'};
	}
}

// viewport heights
@for $i from 0 through 100 {
	.h-#{$i} {
		height: #{$i + 'vh'};
	}
}
</style>
